import Zipcoder from '@/modules/zipcoder';

export default class PaymentAccount {
  constructor() {
    this.wrappers = {
      cnpj: document.querySelector('[data-person-type-fields="cnpj"]'),
      cpf: document.querySelector('[data-person-type-fields="cpf"]'),
    };

    this.opositeWrappers = { cnpj: this.wrappers.cpf, cpf: this.wrappers.cnpj };

    this.personTypes = document.querySelectorAll('[data-person-type]');
  }

  bindPersonType() {
    for (const input of this.personTypes) {
      input.addEventListener('change', (evt) => {
        this.#showPersonType(evt.currentTarget.value);
      });
    }
  }

  init() {
    new Zipcoder({ scope: 'account' }).create();

    this.bindPersonType();

    this.#showPersonType(document.querySelector('[data-person-type]:checked').value);
  }

  #showPersonType(value) {
    this.wrappers[value].classList.remove('hidden');
    this.opositeWrappers[value].classList.add('hidden');
  }
}
